import { AppRegistry, Text, TextInput } from 'react-native';

import { configure } from '@react-native-community/netinfo';

import { Fonts } from 'assets/fonts';

import { name as appName } from './app.json';
import './index.web.css';
import App from './src/App';
import bold from './src/assets/fonts/Montserrat-Bold.woff2';
import regular from './src/assets/fonts/Montserrat-Regular.woff2';

configure({
    reachabilityShouldRun: () => false,
});

Text.defaultProps = Text.defaultProps || {};
Text.defaultProps.allowFontScaling = false;
TextInput.defaultProps = Text.defaultProps || {};
TextInput.defaultProps.allowFontScaling = false;

const regularFontStyles = `@font-face {
  src: url(${regular});
  font-family: ${Fonts.main.regular};
}`;

const boldFontStyles = `@font-face {
  src: url(${bold});
  font-family: ${Fonts.main.bold};
}`;

// Needed to use custom fonts in web app
const style = document.createElement('style');
style.type = 'text/css';

if (style.styleSheet) {
    style.styleSheet.cssText = regularFontStyles;
} else {
    style.appendChild(document.createTextNode(regularFontStyles));
    style.appendChild(document.createTextNode(boldFontStyles));
}
document.head.appendChild(style);

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
    initialProps: {},
    rootTag: document.getElementById('app-root'),
});

if (module.hot) {
    module.hot.accept();
}
